import React, { useState } from "react";
import { TableContainer, Paper, Typography, Box } from "@mui/material";
import NoDataFound from "../../../Components/Masters/NoDataFound";
import PaginationBox from "../../../Components/Masters/Pagination";
import { getMonthName } from "../../../utils/getMonthName";
import DocFiles from "../DocFiles";
import { fixedPercentage } from "../../../utils/common";

function TableDocument({
  data,
  totalPages,
  headers,
  page = 1,
  handleChangePage,
  columnWidth,
  tableContainerRef,
  isShortContent,
}) {
  const [openDoc, setOpenDoc] = useState({});

  const handleChangeView = (data) => {
    setOpenDoc((prevState) => ({
      ...prevState,
      [data._id]: !prevState[data._id], // Toggle visibility for the clicked row based on _id
    }));
  };

  return (
    <Box>
      <TableContainer
        component={Paper}
        ref={tableContainerRef}
        sx={{ maxWidth: "100%" }}
      >
        <Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: columnWidth,
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {headers.map((el) => (
              <Typography
                sx={{
                  height: "100%",
                  fontWeight: "bold",
                  padding: "8px 12px",
                  paddingY: "10px",
                  textAlign: el?.title === "Date" ? "center" : "left",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {el?.title}
              </Typography>
            ))}
            <Typography
              sx={{
                fontWeight: "bold",
                padding: "8px 12px",
                paddingY: "10px",
                textAlign: "center",
              }}
            >
              Documents
            </Typography>
          </Box>
          {data.length === 0 ? (
            <NoDataFound />
          ) : (
            data?.map((item) => (
              <Box
                key={item._id}
                sx={{
                  display: "grid",
                  gridTemplateColumns: columnWidth,
                  borderBottom: "1px solid #ddd",
                }}
              >
                {console.log(headers, "datafor Headers", data)}
                {headers.map((el) => (
                  <Typography
                    sx={{
                      textAlign: "left",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      color: "black",
                      padding: "8px 12px",
                      paddingTop: "1rem",
                    }}
                  >
                    {
                      el?.key === "createdAt" || el?.key === "dateOfTravel"
                        ? new Date(item[el?.key]).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : el?.key === "consumptionPeriod"
                        ? getMonthName(item[el?.key]?.month) +
                          ", " +
                          item[el?.key]?.year
                        : el?.key === "efficiency"
                        ? fixedPercentage(item[el?.key])
                        : el?.key === "equipment"
                        ? item[el?.key]?.equipment
                        : el.key === "vendor"
                        ? item[el.key]?.VendorLegalFullName
                        : el.key === "quantityConsumed"
                        ? item[el.key].value + " " + item[el.key].unit
                        : el.key === "quantityOfWasteGenerated"
                        ? item[el.key].value + " " + item[el.key].unit
                        : el.key === "purchases"
                        ? item[el.key].vendorLegalName
                        : el.key === "quantityOfWasteManaged"
                        ? item[el.key].value + " " + item[el.key].unit
                        : typeof item[el.key] === "object" &&
                          item[el.key][el.field] !== null &&
                          item[el.key][el.field]
                        ? item[el.key][el.field]
                        : typeof item[el.key] === "object" &&
                          item[el.key] !== null &&
                          item[el.key].name
                        ? item[el.key].name
                        : item[el.key] || el.key || "N/A" // Show the fieldData or "N/A" if it's falsy
                    }
                  </Typography>
                ))}
                <Typography
                  sx={{
                    padding: "8px 12px",
                    paddingTop: "1rem",
                    color: openDoc[item._id] ? "#FF282C" : "#004DAF",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "21px",
                    fontStyle: "Inter",
                    textAlign: "center",
                  }}
                  onClick={() => handleChangeView(item)}
                >
                  {openDoc[item._id] ? "Close" : "View"}
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    padding: "8px 12px",
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "1rem",
                  }}
                >
                  {openDoc[item._id] && item?.documents?.length > 0 && (
                    <>
                      {item.documents.map((doc, index) => (
                        <Box key={`file-${index}`} sx={{ mb: 2 }}>
                          <Typography sx={{ fontSize: 12, fontWeight: 500, color: '#555', mb: 0.5 }}>
                            {doc.field}
                          </Typography>
                          <DocFiles url={doc.documentUrl} />
                        </Box>
                      ))}
                    </>
                  )}
                </Box>
              </Box>
            ))
          )}
        </Box>
      </TableContainer>
      {/* Pagination */}
      {totalPages > 1 && (
        <PaginationBox
          isShortContent={isShortContent}
          {...{
            totalPages,
            page,
            handleChangePage,
          }}
        />
      )}
    </Box>
  );
}

export default TableDocument;
